<template>
  <ButtonDefinitive
    label="Continuar"
    @click="next"
  />
</template>

<script>
import ButtonDefinitive from '@/components/Button/ButtonDefinitive.vue'

export default {
  name: "Step2-Type2-Footer",
  components: { ButtonDefinitive },
  mounted() {
    this.$nextTick(() => {});
  },
  methods: {
    next() {
      if (!this.currentOrder.origin.lat || !this.currentOrder.origin.lng) {
        return this.showError('Ahora las direcciones deben estar correctamente ubicadas en el mapa 📍. Por favor, actualiza la dirección seleccionada.')
      }
      if (this.validateData() === 'Ok') {
        this.$store.dispatch("SCHARFFPOINT_PROGRESS_NAV_STEP", 3);
        this.$store.dispatch("STYLE_SHOW_PM_QUOTER", false);
        this.$store.dispatch("STYLE_PROGRAMMED_STEP_DIV_THREE_GENERAL");
        this.trackEvent('click_puntos_recojo_paso_2_continuar', 'pickup');
      } else {
        this.showError(this.validateData());
      }
    },
    validateData() {
      return this.$store.getters.SCHARFFPOINT_VALIDATE_STEP_2;
    },
  },
  computed: {
    currentOrder() {
      return this.$store.getters.SCHARFFPOINT_ORDER
    },
  },
};
</script>

<style></style>
